export default "__VITE_ASSET__KSh5US_G__"